import { render } from "./QuestTypeIcon.vue?vue&type=template&id=0b117a18"
import script from "./QuestTypeIcon.vue?vue&type=script&lang=js"
export * from "./QuestTypeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__